import actionCreatorFactory from 'typescript-fsa';

import reduxConfig from '../../config';
import { IngredientInOrder } from '../ingredients/ingredients.types';
import { StockTransactionItem } from '../inventory/inventory.type';
import { Order, ReceiveIngredient, NextOrderData, IngredientReceiveDataPayload } from './orders.types';

const actionCreator = actionCreatorFactory(reduxConfig.appName + '/orders');

export const fetchOrderList = actionCreator.async<{}, Order[]>('GET_ORDER_LIST');
export const getNextOrderData = actionCreator.async<{}, NextOrderData>('GET_NEXT_ORDER_DATA');
export const downloadOrder = actionCreator.async<{ orderId: string; fileName: string }, any>('DOWNLOAD_ORDER');
export const emailOrder = actionCreator.async<{ orderId: string }, any>('EMAIL_ORDER');
export const setOrders = actionCreator<Order[]>('SET_ORDERS');
export const resetIngredient = actionCreator('RESET_INGREDIENT');
export const updateRecord = actionCreator.async<
  { id: string; stockTransactionId: string; record: Partial<IngredientInOrder>; ignoreStock: boolean },
  StockTransactionItem
>('UPDATE_RECORD');
export const deleteRecord = actionCreator.async<
  { stockTransactionId: string; stockTransactionitemId: string; ignoreStock: boolean },
  {}
>('DELETE_RECORD');
export const getIngredientReceiveData = actionCreator.async<IngredientReceiveDataPayload, ReceiveIngredient>(
  'GET_RECEIVE_DATA',
);
export const receiveIngredient = actionCreator.async<IngredientReceiveDataPayload, ReceiveIngredient>(
  'RECEIVE_INGREDIENT',
);
export const updateDeliveryIngredient = actionCreator.async<IngredientReceiveDataPayload, ReceiveIngredient>(
  'UPDATE_DELIVERY_INGREDIENT',
);
